const LEGACY_HOSTS = new Set([
  "bbrboatrentals.com",
  "www.bbrboatrentals.com",
]);

const PUBLIC_ORIGIN = "https://www.bassboatrentals.com";

function isLocalHost(hostname) {
  return hostname === "localhost" || hostname === "127.0.0.1";
}

function isLocalPage() {
  return typeof window !== "undefined" && isLocalHost(window.location.hostname);
}

function rewriteTargetOrigin() {
  if (typeof window !== "undefined" && window.location?.hostname) {
    if (isLocalHost(window.location.hostname)) return null;
    return window.location.origin.replace(/\/$/, "");
  }
  return PUBLIC_ORIGIN;
}

/** Skip old-domain 301s and mixed-content http:// URLs on the live HTTPS site. */
export function normalizeAssetUrl(url) {
  if (!url || typeof url !== "string") return url;
  if (url.startsWith("data:") || url.startsWith("blob:")) return url;

  // Local/dev: keep stored URLs so localhost and staging photos still load.
  if (isLocalPage()) return url;

  try {
    const parsed = new URL(url, PUBLIC_ORIGIN);
    const host = parsed.hostname.toLowerCase();
    const origin = rewriteTargetOrigin() || PUBLIC_ORIGIN;

    // Listings saved during local testing (http://localhost:3000/images/...)
    // must not be requested over HTTP from the live HTTPS site.
    if (isLocalHost(host)) {
      return `${origin}${parsed.pathname}${parsed.search}${parsed.hash}`;
    }

    if (LEGACY_HOSTS.has(host)) {
      return `${origin}${parsed.pathname}${parsed.search}${parsed.hash}`;
    }

    if (parsed.protocol === "http:") {
      parsed.protocol = "https:";
      return parsed.toString();
    }

    return url;
  } catch {
    return url;
  }
}

function normalizeMaybeUrlList(value) {
  if (Array.isArray(value)) {
    return value.map((item) =>
      typeof item === "string" ? normalizeAssetUrl(item) : item
    );
  }
  if (value && typeof value === "object") {
    const next = {};
    Object.keys(value).forEach((key) => {
      next[key] =
        typeof value[key] === "string"
          ? normalizeAssetUrl(value[key])
          : value[key];
    });
    return next;
  }
  return value;
}

export function normalizeListingAssetUrls(listing) {
  if (!listing || typeof listing !== "object") return listing;
  return {
    ...listing,
    featured_image: normalizeAssetUrl(listing.featured_image),
    images: listing.images ? normalizeMaybeUrlList(listing.images) : listing.images,
    avatar: listing.avatar ? normalizeAssetUrl(listing.avatar) : listing.avatar,
  };
}
